import React from "react";
import "./Footer.css";
import { Fade } from "react-awesome-reveal";
import { greeting } from "../../../portfolio";
import {ThemeProps} from "../../styles/themeprops";
import ToggleSwitch from "./ToggleSwitch";
/* eslint-disable jsx-a11y/accessible-emoji */

type PageFooterProps = {
  children: React.ReactNode;
  theme:ThemeProps;
};
const clickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    //ßconst button: HTMLAnchorElement = event.currentTarget;
    window.print();
};

export default function Footer({children,
  theme,
}: PageFooterProps) {
	const currentYear = new Date().getFullYear();
  return (
    <div className="footer-div">
    	<div className="main">
	    	<div id="navFunctionsWrapper" className="row collapse">
	      	<div className="col-1">
	         	<a href="#" title="Seite drucken (öffnet Dialog)" onClick={clickHandler}>drucken</a>
	         </div>
	         <div className="col-1">
	         	<a href="#" aria-haspopup="true" aria-owns="share" title="Mehr anzeigen" className="">empfehlen</a>
	         </div>
	      </div>
      	
      	
      	<div className="row footer-contact">
				  <div className="col-sm-6">
				      <h3>Pariyani</h3>
				      <p></p>
				      <p className="c-contact-footer__address">
				        Falkensteiner Str. 12<br/>
				        61206 Wöllstadt
				      </p>
				      <p>
				        <a href="tel:+49 231 5599-00"><span>+49 1627 363xxx </span></a>&#160;
				        <i className="fa-solid fa-phone" style={{color: '#f8feff'}}></i>
				     </p>
				      <p>
				        <a href="mailto:i@pariyani.com"><span>i@pariyani.com</span></a>&#160;
				        <i className="fa-solid fa-envelope" style={{color: '#f8feff'}}></i>
				     </p>
				  </div>
				  
			  	<div className="col-sm-6">
			      <div className="footer-social float-end">
			        <div className="">
			          <h3 className="text-center">I am social</h3>
			          <div className="row">
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Twitter-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://twitter.com/pariyani" rel="nofollow noreferrer">
									      <i className="fab fa-twitter fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Facebook-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.facebook.com/pariyani" rel="nofollow noreferrer">
									      <i className="fab fa-facebook fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum  Blog von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="http://blog.pariyani.com" rel="noreferrer">
									      <i className="fa fa-rss fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum XING-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.xing.com/profile/Imran_Pariyani/" rel="nofollow noreferrer">
									      <i className="fab fa-xing fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Youtube-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.youtube.com/c/imranpariyani" rel="nofollow noreferrer">
									      <i className="fab fa-youtube fa-2x"></i>
									    </a>
									 </div>
									  <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum LinkedIn-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.linkedin.com/in/pariyani/" rel="nofollow noreferrer">
									      <i className="fab fa-linkedin fa-2x"></i>
									    </a>
									 </div>
									 <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Instagram-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://www.instagram.com/pariyani" rel="nofollow noreferrer">
									      <i className="fab fa-instagram fa-2x"></i>
									    </a>
									 </div>
									 <div className="col-sm footer_social_img">
									    <a title="Externer Link&nbsp;Zum Anchor-Kanal von Pariyani GmbH (Öffnet&nbsp;neues&nbsp;Fenster)" target="_blank" href="https://anchor.fm/pariyani@gmail.com" rel="nofollow noreferrer">
									      <i className="fab fa-spotify fa-2x"></i>
									    </a>
									 </div>
			          </div>
			       </div>
			     </div>
			  </div>
			</div>
							
	      <Fade>
		      <div className="copyright row">
		      	<div className="col">@ Pariyani {currentYear}</div>
		      	
			    <div className="col-8 footer-links-static">
			      <ul>
			        <li><a href="/Service/imprint" title="Impressum &amp; Copyright">Im­pres­s­um &amp; Co­py­right</a></li>
			        <li><a href="/Service/privacy" title="Datenschutzerklärung">Da­ten­schut­z­er­klä­rung</a></li>
			        <li><a href="/Service/accessibility" title="Erklärung zur Barrierefreiheit">Bar­rie­re­frei­heit</a></li>
			        <li><a href="/Service/cookie-policy" title="Cookie Policy">Cookie Policy</a></li>
			        <li><a href="/Service/sitemap" title="Sitemap">Si­te­map</a></li>
			      </ul>
			    </div>
			
		      	<div className="col">
		      		<div className="float-end">
		          Made with <span role="img">❤️</span> by {greeting.title}
		          </div>
		        </div>
		       </div>
		        {/* <ToggleSwitch theme={props.theme} onToggle={props.onToggle}/> */}
	      </Fade>
      </div>
    </div>
  );
}
